import React, { useEffect } from 'react';
import { buildApplyUrl, services } from '../data';
import './Services.css';

const getServiceId = (title) => title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export default function Services({ selectedService = '' }) {
  useEffect(() => {
    if (!selectedService) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      const target = document.getElementById(`service-${selectedService}`);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 120);

    return () => window.clearTimeout(timeoutId);
  }, [selectedService]);

  return (
    <section className="services-section" id="services">
      <div className="container">
        <div className="services-header">
          <p className="section-label">What We Do</p>
          <h2 className="section-title">Our <span>Support</span> Services</h2>
          <p className="services-sub">Nine dedicated service tracks to support every stage of your career journey.</p>
        </div>
        <div className="services-grid">
          {services.map((service) => (
            <div
              key={service.num}
              id={`service-${getServiceId(service.title)}`}
              className={`service-card ${selectedService === getServiceId(service.title) ? 'service-card-selected' : ''}`}
            >
              <div className="service-num">{service.num}</div>
              <div className="service-icon">{service.icon}</div>
              <div className="service-title">{service.title}</div>
              <p className="service-desc">{service.desc}</p>
              <a href={buildApplyUrl(service.title)} className="service-apply">Apply Now</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
